import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Unstable_Grid2';

import { RouterLink } from 'src/routes/components';

import { DashboardContent } from 'src/layouts/dashboard';

import { ReportScopeFilter } from 'src/components/report-filter/ReportScopeFilter';

const REPORT_CARDS = [
  {
    title: 'Aylık Devam Raporu',
    desc: 'Firma ve şube filtreli, çalışan × gün matrisi. Excel & PDF.',
    href: '/dashboard/reports/monthly',
  },
  {
    title: 'En Düzensiz Çalışanlar',
    desc: 'Geç giriş, erken çıkış, devamsızlık ve unutulan çıkış skoruyla sıralama.',
    href: '/dashboard/reports/irregular',
  },
  {
    title: 'En Düzenli Çalışanlar',
    desc: 'En yüksek devam/dakiklik skoruna sahip çalışanlar.',
    href: '/dashboard/reports/regular',
  },
  {
    title: 'Personel Raporu',
    desc: 'Tek çalışan için gün-gün devam dökümü ve aylık çalışma saatleri.',
    href: '/dashboard/reports/employee',
  },
  {
    title: 'Şube Karnesi',
    desc: 'Şubeleri devam oranı ve ortalama skora göre sıralar. Excel & PDF.',
    href: '/dashboard/reports/scorecard',
  },
];

export function ReportsView() {
  return (
      <DashboardContent>
        <Box sx={{ mb: 5 }}>
          <Typography variant="h4">Raporlar</Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1 }}>
            Yetkiniz dahilindeki firma, şube ve çalışanları filtreleyerek detaylı raporlar
            oluşturun. Tüm raporlar Excel ve PDF olarak indirilebilir.
          </Typography>
        </Box>

        <Card sx={{ p: 3, mb: 4 }}>
          <Typography variant="subtitle1" sx={{ mb: 2 }}>
            Kapsam Filtresi
          </Typography>
          <ReportScopeFilter showEmployee />
        </Card>

        <Grid container spacing={3}>
          {REPORT_CARDS.map((c) => (
            <Grid key={c.href} xs={12} sm={6} md={3}>
              <Card
                component={RouterLink}
                href={c.href}
                sx={{
                  height: '100%',
                  textDecoration: 'none',
                  transition: 'transform .15s, box-shadow .15s',
                  '&:hover': { transform: 'translateY(-4px)', boxShadow: 8 },
                }}
              >
                <CardContent>
                  <Stack spacing={1}>
                    <Typography variant="h6">{c.title}</Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                      {c.desc}
                    </Typography>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </DashboardContent>
  );
}
